// extracted by mini-css-extract-plugin
export default {"dropZone":"Dropzone_dropZone__ddXoG","imageIcon":"Dropzone_imageIcon__XmBJv","thumb":"Dropzone_thumb__WGTbT","img":"Dropzone_img__yKJzi","icon":"Dropzone_icon__PAaPy"};